export class AuditProgramResponse {
    auditProgramName: string;
    auditProgramId: string;
    submittedBy: string;
    submittedOn: string;
    wfStatus: string;
    wfType: string;
    financialYear: string;
    quarter: string;
    company: string;
    site: string;
    auditCoveragePeriod: string;
    checked: boolean;
    requisitionId: string;
    wfStatusId: string;
    auditCoverageFromPeriod: string;
    auditCoverageToPeriod: string;
    auditFromPeriod: string;
    auditToPeriod: string;
    companyId: string;
    siteId: string;
    draftReportSubmittedBy: string;
    draftReportSubmittedOn: string;
    auditScopeId: string;
    ncDescription: string;
    ncSubmittedBy: string;
    previousApprover: string;
    nextapprover: string;
    suppDocCount: string;
    scopeId: string;
    scopeDescription: string;
    enableWorkflow: string;
    openAccordionFlag: boolean = false;
    sectionCode: string;
    ncDepartment: string;
    ncSection: string;
    isPreviewAvailable: string;
    fullScreenClass: string = '';
    fullScreenClassTooltip: string;
    cdPdcaStatus: string;
    subObservationId: string;
    observationNumber: string;
}